import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HomeOutlinedIcon, AddIcon, FileIcon } from "../../../icons";
import GlobalLoader from "../../common/GlobalLoader";
import GenerateQuestionBankPopup from "../../common/GenerateQuestionBankPopup";
import QuestionBankViewPopup from "../../common/QuestionBankViewPopup";
import { getQuestionBanks } from "../../../helper/apicalls/questionBank";
import "./../../../styles/admin/questionBank.scss";

const QuestionBankFolderPage = () => {
  const { folderId } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showGeneratePopup, setShowGeneratePopup] = useState(false);
  const [viewBankId, setViewBankId] = useState(null);
  const [isViewPopupOpen, setIsViewPopupOpen] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getQuestionBanks(folderId);
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching question banks for folder:", err);
      setError("Failed to fetch question banks");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (folderId) {
      fetchData();
    }
  }, [folderId]);

  return (
    <>
      <GlobalLoader visible={loading} text="Loading..." />
      <div className="question-bank-container">
        <div className="qb-card">
          <div className="qb-card-header">
            <span>Folder Question Bank</span>
          </div>
          <div className="folder-grid">
            {!loading && !error && (
              <div
                className="folder-item file-item"
                onClick={() => setShowGeneratePopup(true)}
              >
                <div className="folder-icon">
                  <AddIcon />
                </div>
                <div className="folder-name">Add Question Bank</div>
              </div>
            )}

            {!loading &&
              !error &&
              items?.map((qb) => (
                <div
                  key={qb.id}
                  className="folder-item file-item"
                  onClick={() => {
                    if (!qb || !qb.id) return;
                    setViewBankId(qb.id);
                    setIsViewPopupOpen(true);
                  }}
                >
                  <div className="folder-icon">
                    <FileIcon style={{ color: "var(--text-secondary)" }} />
                  </div>
                  <div className="folder-name">{qb.name || qb.id}</div>
                  {qb.published && (
                    <div className="folder-published">Published</div>
                  )}
                </div>
              ))}

            {error && <div className="qb-error">{error}</div>}
          </div>
        </div>
      </div>

      {showGeneratePopup && (
        <GenerateQuestionBankPopup
          open={showGeneratePopup}
          handleClose={() => setShowGeneratePopup(false)}
          context="folder"
          contextKey={folderId}
          folderId={folderId}
          onSave={(payload) => {
            setShowGeneratePopup(false);
            fetchData();
          }}
        />
      )}

      {isViewPopupOpen && (
        <QuestionBankViewPopup
          open={isViewPopupOpen}
          questionBankId={viewBankId}
          context="folder"
          contextKey={folderId}
          onClose={() => {
            setIsViewPopupOpen(false);
            setViewBankId(null);
          }}
        />
      )}
    </>
  );
};

export default QuestionBankFolderPage;
